import { render, staticRenderFns } from "./fwsed-summary-table.vue?vue&type=template&id=93fd507e&"
import script from "./fwsed-summary-table.vue?vue&type=script&lang=js&"
export * from "./fwsed-summary-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports